module.exports = __webpack_public_path__ + "img/comodin-003.129a74dc.svg";